/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-dialog-container[_ngcontent-%COMP%]{margin:24px}.auth[_ngcontent-%COMP%]{margin:auto;width:560px;max-height:650px;padding:0}.auth-container[_ngcontent-%COMP%]{padding:32px 80px 0}.logo[_ngcontent-%COMP%]{height:120px;background-color:#1b5e20}"];
export { styles as styles };
